import type { IColumn } from 'shared/ui/TableNew'
import { formatSecondsToLargestUnit } from 'shared/lib/dayjs'
import type { RowPerformanceComparison } from 'entities/Analytics/model/Table/RowPerformanceComparison'
import { type SearchTypesEnum } from 'widgets/SearchDropdown'
import { getBreakdownColumnName } from 'pages/analytics/lib'
import { BreakdownEntityCell } from 'pages/analytics/ui'

export const getColumns = (
  filterType: SearchTypesEnum | null
): IColumn<RowPerformanceComparison>[] => [
  {
    field: 'name',
    name: getBreakdownColumnName(filterType),
    fullName: getBreakdownColumnName(filterType),
    isDisabledChangeVisible: true,
    renderRowCell: (row) => {
      const { name, breakdownEntity } = row.fields

      return (
        <BreakdownEntityCell
          filterType={filterType}
          breakdownEntity={breakdownEntity}
          fallbackName={name}
        />
      )
    },
  },
  {
    field: 'avg_time_to_first_response',
    name: 'Avg time to first response',
    renderRowCell: (row) => {
      const { avg_time_to_first_response } = row.fields

      return <>{formatSecondsToLargestUnit(avg_time_to_first_response)}</>
    },
  },
  {
    field: 'avg_time_to_response',
    name: 'Avg time to response',
    renderRowCell: (row) => {
      const { avg_time_to_response } = row.fields

      return <>{formatSecondsToLargestUnit(avg_time_to_response)}</>
    },
  },
  {
    field: 'avg_time_to_close',
    name: 'Avg time to close',
    renderRowCell: (row) => {
      const { avg_time_to_close } = row.fields

      return <>{formatSecondsToLargestUnit(avg_time_to_close)}</>
    },
  },
]
